// Переводы текстов интерфейса: ключ — русский текст
const dict = {
 "Оптовый: {{v0}}": "批发价：{{v0}}",
 "вес клиента за один приход сверх порога считается по этой цене (если она ниже обычной)": "客户单次到货超出门槛的重量按此价格计费（如低于常规费率）",
 "свыше": "超过",
 "кг —": "公斤 —",
 "Порог, кг за приход": "门槛，每次到货公斤数",
 "Оптовый тариф, ₸/кг": "批发费率，₸/公斤",
 "свыше {{v0}} кг — {{v1}} ₸/кг": "超过 {{v0}} 公斤 — {{v1}} ₸/公斤",
 "Оптовый тариф филиала сохранён": "分部批发费率已保存",
 "Оптовый тариф филиала убран": "分部批发费率已移除",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий. Оптовый тариф действует только на вес сверх порога и только если он ниже обычного тарифа клиента.": "顺序：客户个人费率（VIP，在客户卡片中）→ 分部费率 → 通用费率。批发费率只适用于超出门槛的重量，且仅当低于客户常规费率时生效。",
 "в т. ч. {{v0}} кг по {{v1}} ₸/кг (оптовый)": "其中 {{v0}} 公斤按 {{v1}} ₸/公斤（批发）",
 "Имя клиента (необязательно)": "客户名字（选填）",
 "Имя клиента": "客户名字",
 "Скопировать приглашение": "复制邀请",
 "Приглашение": "邀请",
 "Забрана курьером": "快递员已揽收",
 "Покинула сортировочный центр": "已离开分拣中心",
 "Прибыла на сортировочный центр": "已到达分拣中心",
 "Передана курьеру для доставки": "派送中",
 "Принята на складе в Китае": "中国仓库已签收",
 "Возврат отправителю": "退回寄件人",
 "Проблема с доставкой": "派送异常",
 "В пути по Китаю": "中国境内运输中",
 " (сегодня)": "（今天）",
 " · есть несохранённые изменения": " · 有未保存的更改",
 " · код {{v0}}": " · 代码 {{v0}}",
 " · тариф {{v0}}": " · 费率 {{v0}}",
 " — не везде задана цена, счета не посчитаются": " — 部分未设置价格，无法计算账单",
 " — не у всех задана ссылка на оплату": " — 部分未设置支付链接",
 "(Добавлен вручную)": "（手动添加）",
 ", читается именно этот лист.": "，读取的正是这张工作表。",
 "ID филиала:": "分部 ID：",
 "Username (ник из адреса доставки):": "Username（收货地址中的昵称）：",
 "Username латиницей": "Username（拉丁字母）",
 "Username латиницей, например Berik7777": "Username（拉丁字母），例如 Berik7777",
 "WhatsApp номер": "WhatsApp 号码",
 "username не указан": "未设置 username",
 "{{v0}} закладок обновлено": "已更新 {{v0}} 个收藏",
 "{{v0}} закладок удалено": "已删除 {{v0}} 个收藏",
 "{{v0}} обновить не удалось": "{{v0}} 个更新失败",
 "{{v0}} треков и закладок удалено": "已删除 {{v0}} 个单号和收藏",
 "{{v0}} удалить не удалось": "{{v0}} 个删除失败",
 "{{v0}} ₸/кг": "{{v0}} ₸/公斤",
 "{{v0}} ₸/кг ({{v1}})": "{{v0}} ₸/公斤（{{v1}}）",
 "· вес": "· 重量",
 "· всего": "· 合计",
 "· не задан общий тариф (раздел «Вес»)": "· 未设置通用费率（“重量”栏目）",
 "· сумма": "· 金额",
 "· тариф": "· 费率",
 "· уже выставлено:": "· 已开账单：",
 "» нет на сайте. Проверьте написание. Если человек ещё не зарегистрирован, запись можно сохранить: счёт выставится после его регистрации с таким username.": "» 网站上没有。请检查拼写。如果此人尚未注册，可先保存记录：待其使用该 username 注册后将自动开具账单。",
 "Админ панель": "管理面板",
 "Адрес склада (его видит клиент в разделе «Склад»)": "仓库地址（客户在“仓库”栏目中可见）",
 "Адрес филиала:": "分部地址：",
 "Адресс китайского склада": "中国仓库地址",
 "Аккаунт": "账户",
 "Аккаунт и пароль": "账户和密码",
 "Баллы": "积分",
 "Баннеры": "横幅",
 "Бонусы обновлены": "积分已更新",
 "В таблице": "表格中",
 "Ваш сайт": "您的网站",
 "Введите ID филиала": "请输入分部 ID",
 "Введите адрес филиала": "请输入分部地址",
 "Введите корректную сумму": "请输入有效金额",
 "Введите название филиала": "请输入分部名称",
 "Введите новый пароль": "请输入新密码",
 "Введите номер телефона пользователя": "请输入用户手机号",
 "Введите текст статуса": "请输入状态文字",
 "Вес (кг)": "重量（公斤）",
 "Вес, кг": "重量，公斤",
 "Взять текущий текст": "使用当前文本",
 "Вперёд →": "下一页 →",
 "Время": "时间",
 "Вручную": "手动",
 "Все": "全部",
 "Все пользователи": "所有用户",
 "Все поля пустые": "所有字段均为空",
 "Все статусы": "所有状态",
 "Все треки": "所有单号",
 "Все уровни": "所有等级",
 "Все филиалы": "所有分部",
 "Всего треков:": "单号总数：",
 "Вы уверены, что хотите удалить пользователя?": "确定要删除该用户吗？",
 "Вы уверены, что хотите удалить этот филиал?": "确定要删除该分部吗？",
 "Выберите дату": "请选择日期",
 "Выберите дату и статус": "请选择日期和状态",
 "Выберите клиента": "请选择客户",
 "Выберите статус": "请选择状态",
 "Выберите филиал:": "请选择分部：",
 "Выбрать все в статусе": "选择该状态下全部",
 "Выбрать всё": "全选",
 "Выбрать статус": "选择状态",
 "Выставить": "开具",
 "Выставить {{v0}} счетов на {{v1}}? Клиенты получат уведомления{{v2}}.": "开具 {{v0}} 张账单，合计 {{v1}}？客户将收到通知{{v2}}。",
 "Выставить {{v0}} счетов на сумму {{v1}} за {{v2}}? Клиенты получат уведомления.": "开具 {{v0}} 张账单，金额 {{v1}}，日期 {{v2}}？客户将收到通知。",
 "Выставить счета": "开具账单",
 "Выставить счета ({{v0}})": "开具账单（{{v0}}）",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}": "已开具账单：{{v0}} 张，合计 {{v1}}{{v2}}",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}.{{v3}}": "已开具账单：{{v0}} 张，合计 {{v1}}{{v2}}。{{v3}}",
 "Глобальный процент успешно обновлен": "全局比例已更新",
 "Да, удалить": "是，删除",
 "Данные профиля отсутствуют или ещё загружаются.": "资料缺失或仍在加载。",
 "Данные успешно обновлены": "数据已更新",
 "Данные успешно сохранены": "数据已保存",
 "Данные успешно сохранены:": "数据已保存：",
 "Дата регистрации": "注册日期",
 "Дата создания": "创建日期",
 "Дата статуса": "状态日期",
 "Дата статуса:": "状态日期：",
 "Действие": "操作",
 "Действия": "操作",
 "Добавить": "添加",
 "Добавить в базу": "录入系统",
 "Добавить примечание": "添加备注",
 "Добавить счёт для": "为以下客户添加账单：",
 "Добавить трек": "添加单号",
 "Добавить трек клиента": "添加客户单号",
 "Добавить трек номер": "添加快递单号",
 "Добавить утерянный товар": "添加遗失物品",
 "Добавить филиал": "添加分部",
 "Добавлен": "已添加",
 "Добавлен вручную": "手动添加",
 "Добавлена:": "添加时间：",
 "Добавлено:": "已添加：",
 "Добавлено: {{v0}} — {{v1}}": "已添加：{{v0}} — {{v1}}",
 "Дополнительная информация": "附加信息",
 "Доступ запрещён": "禁止访问",
 "Доступ к таблице: «Все, у кого есть ссылка — Читатель». Если в ссылке есть": "表格权限：“拥有链接的任何人 — 查看者”。如果链接中包含",
 "Загрузить": "上传",
 "Загрузить баннер": "上传横幅",
 "Загрузить договор": "上传合同",
 "Загрузить полную историю": "加载完整记录",
 "Закладка обновлена": "收藏已更新",
 "Закладка удалена у пользователя": "已从用户处删除收藏",
 "Закрыть": "关闭",
 "Записать всё равно": "仍然保存",
 "Записей": "记录数",
 "Заполните все поля": "请填写所有字段",
 "Из таблицы": "来自表格",
 "Изменения успешно сохранены": "更改已保存",
 "Изменить": "修改",
 "Изменить вес": "修改重量",
 "Изменить статус": "修改状态",
 "Изменить статус трека": "修改单号状态",
 "Или введите трек-номер": "或输入快递单号",
 "Имя": "名",
 "Имя, телефон, username или код": "姓名、手机号、username 或代码",
 "Имя, телефон, личный код или username": "姓名、手机号、个人代码或 username",
 "Информация": "信息",
 "История": "记录",
 "История (": "记录（",
 "История бонусов для": "积分记录：",
 "История обновлений:": "更新记录：",
 "История приходов": "到货记录",
 "История счетов": "账单记录",
 "Итого:": "合计：",
 "Ищу штрих-код… {{v0}}": "正在查找条形码… {{v0}}",
 "К выставлению": "待开账单",
 "К выставлению:": "待开账单：",
 "Камера не найдена. Сфотографируйте штрих-код или введите номер вручную.": "未找到摄像头。请拍摄条形码或手动输入号码。",
 "Клиент найден: {{v0}}": "已找到客户：{{v0}}",
 "Клиент:": "客户：",
 "Клиента «": "客户“",
 "Клиентов": "客户数",
 "Клиенты увидят его в счёте": "客户将在账单中看到",
 "Кол-во товаров": "商品数量",
 "Кол-во:": "数量：",
 "Количество (шт)": "数量（件）",
 "Копию в Google сохранить не удалось: повторите кнопкой ниже.": "无法保存到 Google：请用下方按钮重试。",
 "Копия в Google не сохранена для записей:": "以下记录未保存到 Google：",
 "Копия сохранена в Google": "已保存到 Google",
 "Копия сохранена в Google.": "已保存到 Google。",
 "Личный (VIP)": "个人（VIP）",
 "Личный тариф пользователя (₸ за кг):": "用户个人费率（₸/公斤）：",
 "Личный тариф сохранён": "个人费率已保存",
 "Личный тариф убран": "个人费率已移除",
 "Личный тариф, например 1400": "个人费率，例如 1400",
 "Массовая загрузка": "批量上传",
 "Массовая загрузка утеренных товаров": "批量上传遗失物品",
 "Массовое добавление": "批量添加",
 "Массовое добавление треков": "批量添加单号",
 "Мой карго": "我的货运",
 "На фото штрих-код не прочитался. Нужна резкая картинка, где код занимает заметную часть кадра (не меньше трети ширины). Или введите номер вручную.": "照片中的条形码无法识别。请使用清晰的图片，条码需占画面较大部分（至少三分之一宽度），或手动输入号码。",
 "Нажмите на день в таблице, чтобы открыть его приходы.": "点击表格中的日期查看当天到货。",
 "Название филиала:": "分部名称：",
 "Найден пользователь: {{v0}} {{v1}}": "已找到用户：{{v0}} {{v1}}",
 "Найти": "查找",
 "Например: заберите посылку до пятницы": "例如：请在周五前取件",
 "Например: оплатить до пятницы": "例如：请在周五前付款",
 "Начислить": "增加",
 "Не выбрано": "未选择",
 "Не добавлен": "未添加",
 "Не оплачены": "未支付",
 "Не удалось выставить счета": "无法开具账单",
 "Не удалось загрузить историю приходов": "无法加载到货记录",
 "Не удалось загрузить оферту": "无法加载要约",
 "Не удалось загрузить приёмку": "无法加载收货页面",
 "Не удалось загрузить профиль": "无法加载资料",
 "Не удалось загрузить файл": "无法上传文件",
 "Не удалось запустить камеру. Сфотографируйте штрих-код или введите номер вручную.": "无法启动摄像头。请拍摄条形码或手动输入号码。",
 "Не удалось изменить": "无法修改",
 "Не удалось найти посылку": "未找到包裹",
 "Не удалось обновить закладку": "无法更新收藏",
 "Не удалось обновить профиль": "无法更新资料",
 "Не удалось открыть фото.": "无法打开照片。",
 "Не удалось отправить копию": "无法发送副本",
 "Не удалось прочитать таблицу": "无法读取表格",
 "Не удалось разобрать фото. Введите номер вручную.": "无法识别照片，请手动输入号码。",
 "Не удалось создать счёт": "无法创建账单",
 "Не удалось сохранить": "无法保存",
 "Не удалось сохранить копию в Google": "无法保存到 Google",
 "Не удалось удалить": "无法删除",
 "Не удалось удалить файл": "无法删除文件",
 "Не читается? Нажмите «Сфотографировать код»: снимок обычно читается лучше, чем живая картинка.": "识别不了？请点击“拍摄条码”：照片通常比实时画面更容易识别。",
 "Неизвестен": "未知",
 "Неизвестно": "未知",
 "Необходимо заполнить все поля": "必须填写所有字段",
 "Нет выбранных закладок": "未选择收藏",
 "Нет данных пользователя для загрузки": "没有可加载的用户数据",
 "Нет записей, по которым ещё не выставлен счёт.": "没有尚未开账单的记录。",
 "Нет операций": "暂无记录",
 "Нет рефералов": "暂无推荐用户",
 "Нет треков для добавления": "没有可添加的单号",
 "Ник из адреса доставки клиента. По нему распознаются этикетки посылок.": "客户收货地址中的昵称，用于识别包裹面单。",
 "Новые бонусы": "新增积分",
 "Новый вес для {{v0}}, кг": "{{v0}} 的新重量（公斤）",
 "Новый пароль (оставьте пустым, чтобы не менять):": "新密码（留空则不修改）：",
 "Новый процент": "新比例",
 "Новый счёт": "新账单",
 "Новый филиал успешно добавлен": "新分部已添加",
 "Номер": "编号",
 "Номер для звонка": "通话号码",
 "Номер счёта": "账单编号",
 "Номер:": "编号：",
 "Обновить выбранные": "更新所选",
 "Обновить процент": "更新比例",
 "Обновить филиал": "更新分部",
 "Общая сумма": "总金额",
 "Общее кол-во": "总数量",
 "Общее примечание ко всем счетам (необязательно). Своё примечание клиенту можно написать в таблице выше": "所有账单的通用备注（可选）。给单个客户的备注可在上方表格中填写",
 "Общий": "通用",
 "Общий вес": "总重量",
 "Общий тариф": "通用费率",
 "Общий тариф нужно указать числом, например 1800": "通用费率须为数字，例如 1800",
 "Общий тариф сохранён": "通用费率已保存",
 "Он показывается на странице «Публичная оферта» (доступна без входа). Если оставить поле пустым, показывается встроенный текст.": "显示在“公开要约”页面（无需登录即可访问）。如留空，则显示内置文本。",
 "Описание": "备注",
 "Оплата и склад по филиалам": "各分部的支付与仓库",
 "Оплачено": "已支付",
 "Оплачены": "已支付",
 "Открываю карточку…": "正在打开客户卡片…",
 "Открыть карточку клиента": "打开客户卡片",
 "Открыть страницу": "打开页面",
 "Открыть треки": "打开单号",
 "Отменены": "已取消",
 "Отменить": "取消",
 "Отменить счёт": "取消账单",
 "Отменить счёт {{v0}}?": "取消账单 {{v0}}？",
 "Отмечен оплаченным": "已标记为已支付",
 "Отправить в Google": "发送到 Google",
 "Отправить счёт": "发送账单",
 "Отправка...": "发送中...",
 "Оферта сохранена": "要约已保存",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий.": "优先顺序：客户个人费率（VIP，在客户卡片中）→ 分部费率 → 通用费率。",
 "Ошибка": "错误",
 "Ошибка при загрузке закладок": "加载收藏失败",
 "Ошибка при загрузке полной истории": "加载完整记录失败",
 "Ошибка при загрузке пользователей": "加载用户失败",
 "Ошибка при загрузке рефералов": "加载推荐用户失败",
 "Ошибка при массовом добавлении треков": "批量添加单号失败",
 "Ошибка при массовом обновлении": "批量更新失败",
 "Ошибка при обновлении бонусов": "更新积分失败",
 "Ошибка при обновлении данных": "更新数据失败",
 "Ошибка при обновлении процента пользователя": "更新用户比例失败",
 "Ошибка при операции": "操作失败",
 "Ошибка при оплате счёта": "账单支付失败",
 "Ошибка при применении трека": "应用单号失败",
 "Ошибка при редактировании счёта": "编辑账单失败",
 "Ошибка при сканировании": "扫描出错",
 "Ошибка при создании счёта": "创建账单失败",
 "Ошибка при сохранении глобального процента": "保存全局比例失败",
 "Ошибка при сохранении данных": "保存数据失败",
 "Ошибка при сохранении данных:": "保存数据失败：",
 "Ошибка при сохранении изменений": "保存更改失败",
 "Ошибка при удалении пользователя": "删除用户失败",
 "Ошибка при удалении счёта": "删除账单失败",
 "Ошибка при удалении трека": "删除单号失败",
 "Ошибка: {{v0}}": "错误：{{v0}}",
 "Пароль должен содержать от 6 до 64 символов": "密码长度须为 6 至 64 个字符",
 "Партия (дата)": "批次（日期）",
 "По статусам": "按状态",
 "По филиалам": "按分部",
 "Повторить загрузку": "重新加载",
 "Подождите…": "请稍候…",
 "Подсветку включить не удалось.": "无法打开补光灯。",
 "Подтвердить": "确认",
 "Поиск": "搜索",
 "Поиск по имени или телефону": "按姓名或手机号搜索",
 "Поиск по имени, фамилии или телефону": "按名、姓或手机号搜索",
 "Поиск по клиенту, телефону, счёту...": "按客户、手机号、账单搜索...",
 "Пока пусто.": "暂无内容。",
 "Показать ещё": "显示更多",
 "Поле процента пустое": "比例字段为空",
 "Поле трек не может быть пустым": "单号不能为空",
 "Полная история загружена": "完整记录已加载",
 "Пользователи (упрощённый список)": "用户（简化列表）",
 "Пользователь": "用户",
 "Пользователь с номером {{v0}} не найден": "未找到号码为 {{v0}} 的用户",
 "Пользователь удалён": "用户已删除",
 "Поместите штрих-код в зелёную рамку и держите ровно 1–3 секунды. Нажимать на экран не нужно — код читается сам.": "将条形码放入绿色框内并保持 1–3 秒。无需点击屏幕，将自动识别。",
 "Последний отсканированный ID:": "最近扫描的 ID：",
 "Посмотреть рефералов": "查看推荐用户",
 "Посылка {{v0}} → {{v1}} {{v2}}{{v3}}": "包裹 {{v0}} → {{v1}} {{v2}}{{v3}}",
 "Посылка {{v0}}: {{v1}}. Выберите клиента вручную.": "包裹 {{v0}}：{{v1}}。请手动选择客户。",
 "Потеряшки": "遗失物品",
 "Предедущая страница": "上一页",
 "Примечание для клиента (необязательно)": "给客户的备注（可选）",
 "Примечание к счетам (необязательно)": "账单备注（可选）",
 "Примечание к счёту {{v0}} (клиент увидит его в счёте; пусто — убрать)": "账单 {{v0}} 的备注（客户将在账单中看到；留空则删除）",
 "Примечание сохранено": "备注已保存",
 "Примечание только для этого клиента (например, ссылка на постамат)": "仅此客户的备注（例如取件柜链接）",
 "Принял": "接收人",
 "Приходы за": "到货日期：",
 "Приёмка": "收货",
 "Пробить сканером...": "用扫码枪扫描...",
 "Произошла ошибка при добавлении трека": "添加单号时出错",
 "Произошла ошибка при добавлении/редактировании филиала": "添加/编辑分部时出错",
 "Произошла ошибка при удалении филиала": "删除分部时出错",
 "Пропущено строк таблицы:": "跳过的表格行数：",
 "Профиль загружен": "资料已加载",
 "Профиль:": "资料：",
 "Процент": "比例",
 "Процент пользователя обновлен": "用户比例已更新",
 "Пусто — показывается встроенный текст. Нажмите «Взять текущий текст», чтобы начать с него.": "留空则显示内置文本。点击“使用当前文本”可在其基础上编辑。",
 "Разбираю фото… {{v0}}%": "正在识别照片… {{v0}}%",
 "Разметка:": "格式：",
 "Разрешите доступ к камере в настройках браузера для этого сайта.": "请在浏览器设置中允许此网站使用摄像头。",
 "Рассылка": "群发",
 "Расширить": "展开",
 "Редактирование пользователя": "编辑用户",
 "Редактировать": "编辑",
 "Редактировать закладку": "编辑收藏",
 "Реквизиты сохранены": "收款信息已保存",
 "Рефералы пользователя:": "用户的推荐用户：",
 "Роль": "角色",
 "Роль:": "角色：",
 "Свежие по дате": "最新优先",
 "Свернуть": "收起",
 "Сейчас применяется:": "当前适用：",
 "Сканер посылки": "包裹扫描",
 "Сканер штрих-кода": "条形码扫描",
 "Сканирование QR доступно только администраторам": "仅管理员可使用扫码",
 "Сканирование QR-кода": "扫描二维码",
 "Сканирование посылок": "扫描包裹",
 "Сканировать QR": "扫描二维码",
 "Скачать файл": "下载文件",
 "Сменить клиента": "更换客户",
 "Сначала выберите дату и статус, потом сканируйте посылки": "请先选择日期和状态，再扫描包裹",
 "Снять выбор": "取消选择",
 "Создать": "创建",
 "Создать счёт": "创建账单",
 "Создать/обновить трек {{v0}} в общей базе?": "在公共数据库中创建/更新单号 {{v0}}？",
 "Создаётся автоматически из личного кода клиента: XXX-0001, XXX-0002…": "根据客户个人代码自动生成：XXX-0001、XXX-0002…",
 "Сортировка по активности": "按活跃度排序",
 "Состояние": "状态",
 "Сохранение...": "保存中...",
 "Сохранить": "保存",
 "Сохранить изменения": "保存更改",
 "Списать": "扣除",
 "Списать/начислить баллы": "扣除/增加积分",
 "Списать/начислить баллы для": "为以下客户扣除/增加积分：",
 "Список посылок": "包裹列表",
 "Список треков": "单号列表",
 "Список треков для массового добавления:": "批量添加的单号列表：",
 "Ссылка на Google-таблицу": "Google 表格链接",
 "Ссылка на ватсап": "WhatsApp 链接",
 "Ссылка на инструкцию (youtube, vimeo)": "使用说明链接（YouTube、Vimeo）",
 "Ссылка на оплату (Kaspi и т.п.)": "支付链接（Kaspi 等）",
 "Ссылка показывается клиенту кнопкой «Оплатить» в неоплаченном счёте. У каждого филиала своя.": "该链接在未支付账单中以“去支付”按钮显示给客户。每个分部各有自己的链接。",
 "Старые по дате": "最早优先",
 "Статистика": "统计",
 "Статус": "状态",
 "Статусы": "状态",
 "Сумма": "金额",
 "Сумма (₸) *": "金额（₸）*",
 "Сумма баллов": "积分数量",
 "Сумма появится после ввода веса": "输入重量后将显示金额",
 "Суммы расходятся со столбцом Payment в": "金额与 Payment 列不一致，涉及",
 "Счета выставлены на": "已开具账单，合计",
 "Счета из таблицы поступлений": "来自到货表格的账单",
 "Счета отсутствуют": "暂无账单",
 "Счетов нет": "暂无账单",
 "Счёт отменён": "账单已取消",
 "Счёт отправлен клиенту": "账单已发送给客户",
 "Счёт удалён": "账单已删除",
 "Счёт успешно создан": "账单创建成功",
 "Тариф": "费率",
 "Тариф филиала сохранён": "分部费率已保存",
 "Тариф филиала убран — действует общий": "分部费率已移除，适用通用费率",
 "Тариф, ₸/кг": "费率，₸/公斤",
 "Тарифы, ₸/кг": "费率，₸/公斤",
 "Текст \"О нас\"": "“关于我们”文本",
 "Текст \"Товары которые нельзя заказывать\"": "“禁止订购的商品”文本",
 "Текст оферты.": "要约文本。",
 "Текст очищен: будет показан встроенный вариант": "文本已清空，将显示内置版本",
 "Текущий договор:": "当前合同：",
 "Текущий статус:": "当前状态：",
 "Текущий файл:": "当前文件：",
 "Телефон:": "电话：",
 "Тип:": "类型：",
 "Требуется авторизация администратора": "需要管理员登录",
 "Трек": "单号",
 "Трек номер:": "快递单号：",
 "Трек применён в базе": "单号已在数据库中应用",
 "Трек удалён": "单号已删除",
 "Трека": "单号",
 "Треки": "单号",
 "Треки (по статусам)": "单号（按状态）",
 "Треки клиента": "客户的单号",
 "Треки отсутствуют": "暂无单号",
 "Треки прикрепленные пользователями, но не найденные": "用户已绑定但未找到的单号",
 "Треки успешно обновлены или созданы": "单号已更新或创建",
 "Убрать": "移除",
 "Убрать у клиента": "从客户处移除",
 "Удалить": "删除",
 "Удалить {{v0}} закладок у пользователя и соответствующие треки из базы?": "删除用户的 {{v0}} 个收藏及数据库中对应的单号？",
 "Удалить {{v0}} закладок у пользователя?": "删除用户的 {{v0}} 个收藏？",
 "Удалить выбранные из базы": "从数据库删除所选",
 "Удалить закладку {{v0}} у пользователя?": "删除用户的收藏 {{v0}}？",
 "Удалить запись {{v0}} — {{v1}}?": "删除记录 {{v0}} — {{v1}}？",
 "Удалить из базы": "从数据库删除",
 "Удалить профиль": "删除资料",
 "Удалить счёт {{v0}} безвозвратно?": "永久删除账单 {{v0}}？",
 "Удалить трек {{v0}} из системы? Это действие повлияет на всех пользователей.": "从系统中删除单号 {{v0}}？此操作将影响所有用户。",
 "Укажите вес в кг, например 2.85": "请填写重量（公斤），例如 2.85",
 "Укажите клиента": "请指定客户",
 "Укажите сумму больше нуля": "请输入大于零的金额",
 "Уровень": "等级",
 "Успешно загружено!!": "上传成功！",
 "Установить": "设置",
 "Установить статус выбранным закладкам ({{v0}})?": "为所选收藏（{{v0}}）设置状态？",
 "Файл загружен": "文件已上传",
 "Файл оферты (PDF, DOC, DOCX)": "要约文件（PDF、DOC、DOCX）",
 "Фамилия": "姓",
 "Филиал": "分部",
 "Филиал не указан": "未指定分部",
 "Филиал успешно обновлен": "分部已更新",
 "Филиал успешно удален": "分部已删除",
 "Филиала": "分部",
 "Фильтр:": "筛选：",
 "Фильтры и массовые операции — ниже. Нажмите «Открыть треки», чтобы начать работу.": "筛选和批量操作在下方。点击“打开单号”开始操作。",
 "Функция еще в разработке...": "该功能仍在开发中...",
 "Хозяин посылки не найден, выберите клиента вручную": "未找到包裹所属客户，请手动选择",
 "Цена за кг": "每公斤价格",
 "Читаю…": "识别中…",
 "баллов —": "积分 —",
 "без username": "无 username",
 "все счета выставлены": "账单已全部开具",
 "выставлен": "已开具",
 "день": "天",
 "добавлен ({{v0}})": "已添加（{{v0}}）",
 "ждут счёта:": "待开账单：",
 "запасной: для филиалов без своей цены": "备用：适用于未设置价格的分部",
 "изменить": "修改",
 "изменить ▼": "修改 ▼",
 "индивидуальных примечаний: {{v0}}": "个别备注：{{v0}}",
 "к выставлению": "待开账单",
 "как общий": "同通用",
 "кг •": "公斤 •",
 "кг,": "公斤，",
 "личный": "个人",
 "меню": "菜单",
 "не задан": "未设置",
 "не задан — показывается общий адрес": "未设置，将显示通用地址",
 "не привязан": "未绑定",
 "нет": "无",
 "нет в базе. Проверьте номер или добавьте посылку.": "数据库中没有。请检查号码或添加包裹。",
 "нет приходов": "无到货",
 "нет ссылки": "无链接",
 "общий": "通用",
 "общий {{v0}}": "通用 {{v0}}",
 "общий не задан": "通用未设置",
 "ожидает": "等待中",
 "открыть": "打开",
 "подробнее ▼": "详情 ▼",
 "с общим примечанием": "含通用备注",
 "свернуть ▲": "收起 ▲",
 "своя цена не задана — действует общая": "未设置专属价格，适用通用价格",
 "сегодня": "今天",
 "ссылка есть": "已设置链接",
 "стр. {{v0}}: {{v1}}": "第 {{v0}} 行：{{v1}}",
 "строках (отмечены ⚠). Обычно это клиенты со скидкой: задайте им личный тариф в «Все пользователи → Изменить».": "行中（标有 ⚠）。通常是有折扣的客户：请在“所有用户 → 修改”中为其设置个人费率。",
 "счетов ·": "张账单 ·",
 "тариф не задан": "未设置费率",
 "тариф филиала": "分部费率",
 "удалить": "删除",
 "указать": "填写",
 "шт •": "件 •",
 "шт,": "件，",
 "— клиентов:": "— 客户数：",
 "₸/кг": "₸/公斤",
 "← Вернуться к информации": "← 返回信息",
 "← На сайт": "← 返回网站",
 "← Назад": "← 返回",
 "⏳ Ожидает": "⏳ 等待中",
 "⚖️ Приёмка": "⚖️ 收货",
 "✎ Примечание": "✎ 备注",
 "✎ примечание": "✎ 备注",
 "✓ Выставить {{v0}} счетов": "✓ 开具 {{v0}} 张账单",
 "✓ Оплачено": "✓ 已支付",
 "✓ Отправить счёт": "✓ 发送账单",
 "✕ Отмена": "✕ 取消",
 "＋ Примечание": "＋ 备注",
 "📋 Управление счетами": "📋 账单管理",
 "📦 Треки (": "📦 单号（",
 "📷 Сканировать": "📷 扫描",
 "📷 Сканировать камерой телефона": "📷 用手机摄像头扫描",
 "📷 Сканировать посылку": "📷 扫描包裹",
 "📸 Сфотографировать код": "📸 拍摄条码",
 "🔦 Включить подсветку": "🔦 打开补光灯",
 "🔦 Выключить подсветку": "🔦 关闭补光灯",
 "🖼 Фото из галереи": "🖼 从相册选择",
 "% Глобальный процент партнера": "% 合作伙伴全局比例",
 "— выделение; абзацы разделяйте пустой строкой.": "— 加粗强调；段落之间用空行分隔。",
 "— заголовок документа;": "— 文档标题；",
 "— необязательно; ссылка на скачивание показывается на странице, если текст не задан.": "— 可选；如未设置文本，页面将显示下载链接。",
 "— подзаголовок;": "— 副标题；",
 "— раздел (сворачивается);": "— 章节（可折叠）；",
 "— список;": "— 列表；",
 "В файле не найдено треков": "文件中未找到单号",
 "В файле больше 2000 треков — разбейте на части": "文件中单号超过 2000 个，请分批上传",
 "Файл {{v0}}: найдено треков {{v1}}{{v2}}{{v3}}. Проверьте дату и статус и нажмите «Загрузить».": "文件 {{v0}}：找到 {{v1}} 个单号{{v2}}{{v3}}。请检查日期和状态，然后点击“上传”。",
 ", код филиала {{v0}}": "，分部代码 {{v0}}",
 ", дата {{v0}}": "，日期 {{v0}}",
 "Не удалось прочитать файл: {{v0}}": "无法读取文件：{{v0}}",
 "📎 Загрузить файл (xlsx, csv, txt)": "📎 上传文件（xlsx、csv、txt）",
 "Вы уверены, что хотите удалить эту закладку?": "确定要删除此收藏吗？",
 "Закладка удалена": "收藏已删除",
 "Ошибка при удалении закладки": "删除收藏失败",
 "Описание:": "备注：",
 "Загрузка...": "加载中...",
 "Подтвердить получение": "确认收货",
 "Токен отсутствует. Пожалуйста, войдите в систему снова.": "缺少登录令牌，请重新登录。",
 "Username сохранён.": "Username 已保存。",
 "Не удалось сохранить username.": "无法保存 Username。",
 "Ошибка при отправке запроса.": "发送请求失败。",
 "Пароль успешно обновлен.": "密码已成功更新。",
 "Ошибка при смене пароля.": "修改密码失败。",
 "Заполните обязательные поля": "请填写必填项",
 "Объявление обновлено": "公告已更新",
 "Объявление создано и отправлено всем пользователям": "公告已创建并发送给所有用户",
 "Ошибка при сохранении объявления": "保存公告失败",
 "Вы уверены?": "确定吗？",
 "Объявление удалено": "公告已删除",
 "Ошибка при удалении объявления": "删除公告失败",
 "Доступ запрещен": "禁止访问",
 "Управление объявлениями": "公告管理",
 "✕ Закрыть форму": "✕ 关闭表单",
 "+ Новое объявление": "+ 新公告",
 "Заголовок *": "标题 *",
 "Введите заголовок": "请输入标题",
 "Сообщение *": "内容 *",
 "Введите сообщение": "请输入内容",
 "URL изображения": "图片链接",
 "💾 Обновить": "💾 更新",
 "💾 Создать": "💾 创建",
 "Отмена": "取消",
 "Объявления (": "公告（",
 "Объявлений нет": "暂无公告",
 "Ошибка при загрузке архива": "加载归档失败",
 "Запись удалена из архива": "记录已从归档中删除",
 "Ошибка при удалении": "删除失败",
 "Загрузка архива...": "正在加载归档...",
 "Архив пуст": "归档为空",
 "В архиве": "已归档",
 "УДАЛИТЬ": "删除",
 "История статусов": "状态记录",
 "Добавлен в базу": "已录入系统",
 "Загрузка…": "加载中…",
 "Показать ещё ({{v0}})": "显示更多（{{v0}}）",
 "Архив": "归档",
 "Загрузка ...": "加载中 ...",
 "Показано": "已显示",
 "из": "共",
 "архивированных посылок": "个已归档包裹",
 "Дата регистрации клиентом:": "客户登记日期：",
 "нет данных": "暂无数据",
 "Дата получения:": "签收日期：",
 "Страница": "页",
 "Баннер": "横幅",
 "Логотип": "标志",
 "Надёжный карго-сервис с отслеживанием и прозрачной логистикой": "可靠的货运服务，包裹可追踪，物流透明",
 "Войти": "登录",
 "Регистрация": "注册",
 "Перейти в систему": "进入系统",
 "Публичная оферта": "公开要约",
 "Ошибка при обновлении и получении счета: {{v0}}": "更新并获取账单时出错：{{v0}}",
 "Загрузка счета...": "正在加载账单...",
 "Нет неоплаченных счетов": "没有未付账单",
 "Счёт за доставку от": "配送账单，日期：",
 "Поступило заказов -": "已收订单 -",
 "шт": "件",
 "Вес": "重量",
 "кг, сумма к оплате": "公斤，应付金额",
 "Главная": "首页",
 "Посылки": "包裹",
 "Профиль": "我的",
 "Панель управления": "控制面板",
 "Поиск...": "搜索...",
 "Найдено:": "找到：",
 "Трек-код": "快递单号",
 "Дата": "日期",
 "Предыдущая страница": "上一页",
 "Следующая страница": "下一页",
 "Номер страницы:": "页码：",
 "Кол-во страниц:": "总页数：",
 "Доступен 09:00 - 18:00 (МСК)": "在线时间 09:00 - 18:00（莫斯科时间）",
 "Статус клиента": "客户等级",
 "Бонусные баллы": "积分",
 "Общие затраты": "累计消费",
 "Рефералы": "推荐用户",
 "Информация аккаунта": "账户信息",
 "Успешно добавлен": "添加成功",
 "404 - Страница не найдена": "404 - 页面未找到",
 "К сожалению, запрашиваемая страница не существует.": "抱歉，您访问的页面不存在。",
 "Вернуться на главную": "返回首页",
 "Ошибка при получении уведомлений": "获取通知失败",
 "Уведомление удалено": "通知已删除",
 "Счета": "账单",
 "Объявления": "公告",
 "Уведомления": "通知",
 "Загрузка уведомлений...": "正在加载通知...",
 "Нет уведомлений": "暂无通知",
 "Трек:": "单号：",
 "Сумма:": "金额：",
 "Вес:": "重量：",
 "кг": "公斤",
 "Объявление": "公告",
 "✓ Прочитано": "✓ 已读",
 "● Новое": "● 新",
 "Получение подтверждено!": "已确认收货！",
 "Произошла ошибка при подтверждении получения.": "确认收货时出错。",
 "посылок": "个包裹",
 "неизвестно": "未知",
 "Данные скопированы в буфер обмена": "已复制到剪贴板",
 "Не удалось скопировать — попробуйте вручную": "复制失败，请手动复制",
 "Не удалось получить доступ к камере": "无法访问摄像头",
 "Клиент найден!": "已找到客户！",
 "Клиент не найден": "未找到客户",
 "Ошибка при поиске клиента": "查找客户失败",
 "Сканирование клиентов через QR": "扫码查找客户",
 "Отсканируйте QR код клиента или введите номер телефона": "扫描客户二维码或输入手机号",
 "⚠️ Доступ к камере запрещен": "⚠️ 摄像头权限被拒绝",
 "Пожалуйста, разрешите доступ к камере в настройках браузера": "请在浏览器设置中允许访问摄像头",
 "🛑 Остановить сканирование": "🛑 停止扫描",
 "📷 Начать сканирование": "📷 开始扫描",
 "Введите номер телефона клиента": "请输入客户手机号",
 "🔍 Поиск": "🔍 搜索",
 "Загрузка данных клиента...": "正在加载客户信息...",
 "Данные клиента": "客户信息",
 "Имя:": "姓名：",
 "Номер телефона:": "手机号：",
 "Не указан": "未填写",
 "Статус:": "状态：",
 "Администратор": "管理员",
 "Клиент": "客户",
 "Уровень:": "等级：",
 "Стандартный": "标准",
 "Филиал:": "分部：",
 "Бонусы:": "积分：",
 "Дата регистрации:": "注册日期：",
 "Реферальный код:": "推荐码：",
 "📷 Отсканировать другого": "📷 扫描其他客户",
 "Клиент с номером": "号码为",
 "не найден": "的客户未找到",
 "Попробовать снова": "重试",
 "Реферальная ссылка скопирована!": "推荐链接已复制！",
 "Пользователи, зарегистрированные по вашей реферальной ссылке": "通过您的推荐链接注册的用户",
 "Фамилия:": "姓：",
 "Партнерская программа": "合作伙伴计划",
 "Ваша реферальная ссылка:": "您的推荐链接：",
 "Пожалуйста, авторизуйтесь": "请先登录",
 "Мой QR код": "我的二维码",
 "Покажите этот QR код администратору для быстрого поиска вашей информации": "向管理员出示此二维码，以便快速查找您的信息",
 "📥 Скачать QR код": "📥 下载二维码",
 "✅ Скопировано": "✅ 已复制",
 "📋 Копировать номер": "📋 复制号码",
 "Ошибка при загрузке счетов": "加载账单失败",
 "Неоплаченные счета": "未付账单",
 "Дата:": "日期：",
 "Товаров:": "商品数：",
 "тг": "₸",
 "Не оплачено": "未支付",
 "Не оплачен": "未支付",
 "Оплачен": "已支付",
 "Отменён": "已取消",
 "Бонусы": "积分",
 "Баланс бонусов": "积分余额",
 "У вас 1200 бонусов. Используйте их при оформлении заказа.": "您有 1200 积分，下单时可使用。",
 "Контакты": "联系方式",
 "Загрузка контактов...": "正在加载联系方式...",
 "Свяжитесь с нами": "联系我们",
 "Ваш филиал: {{v0}}. ": "您的分部：{{v0}}。",
 "Выберите удобный для вас способ связи": "请选择方便您的联系方式",
 "Телефон": "电话",
 "Позвонить": "拨打",
 "Напишите нам": "给我们留言",
 "Написать": "发送消息",
 "Наш канал": "我们的频道",
 "Перейти": "前往",
 "Следить": "关注",
 "Контакты не доступны в данный момент": "暂时无法显示联系方式",
 "Филиалы": "分部",
 "Наши филиалы": "我们的分部",
 "Владелец:": "负责人：",
 "Филиалы не найдены": "未找到分部",
 "Мои счета": "我的账单",
 "Не удалось загрузить счета": "无法加载账单",
 "Счетов пока нет": "暂无账单",
 "Счёт": "账单",
 "Количество:": "数量：",
 "Оплатить": "去支付",
 "Отслеживание груза": "货物追踪",
 "Реал-тайм информация о статусе посылки": "包裹状态实时信息",
 "Консультация по расчету": "费用核算咨询",
 "Помощь с расчетом стоимости доставки": "协助计算运费",
 "Оформление документов": "办理单证",
 "Помощь в оформлении таможенных документов": "协助办理清关文件",
 "Логистические решения": "物流方案",
 "Индивидуальные предложения для крупных грузов": "大宗货物专属方案",
 "Сколько времени занимает доставка?": "运输需要多长时间？",
 "Срок доставки товаров из Китая в Казахстан составляет 8–15 дней. Счёт дней начинается с момента отправки товара со склада в Китае. В случае форс-мажора, праздников или работы таможни, сроки доставки могут измениться. Карго не несёт ответственность за задержки, вызванные указанными обстоятельствами.": "从中国运至哈萨克斯坦的时效为 8–15 天，自货物从中国仓库发出之日起计算。遇不可抗力、节假日或海关查验等情况，时效可能发生变化。因上述情况造成的延误，货运公司不承担责任。",
 "Как работает страхование груза?": "货物保险如何运作？",
 "Клиент может оформить страховку при отправке через Карго. Стоимость страховки: 1% от стоимости груза (минимум 2 500 ₸). Страховка покрывает только заявленную стоимость товара по скриншоту. Если груз не застрахован, Карго не несёт ответственности за повреждение, потерю или недостачу. Отказаться от страховки можно только до отправки груза со склада.": "客户在通过货运公司发货时可办理保险。保费为货值的 1%（最低 2 500 ₸）。保险仅按截图申报的商品价值赔付。未投保的货物如有损坏、丢失或短少，货运公司不承担责任。仅可在货物离开仓库之前取消保险。",
 "Какие документы требуются?": "需要哪些文件？",
 "Требуется паспорт и таможенный декларат. Наш менеджер поможет вам с оформлением всех необходимых документов. Для хрупких товаров требуется деревянная обрешётка (стоимость 10 USD). Клиент обязан заранее уведомить карго о хрупком товаре.": "需要护照和报关单。我们的经理会协助您办理所有必要文件。易碎品需要木箱包装（费用 10 美元）。客户须提前告知货运公司货物为易碎品。",
 "Какова ответственность компании?": "公司承担哪些责任？",
 "Компания отвечает только за товары, которые поступили на склад и отображены на сайте. Ответственность за сохранность груза несёт только филиал Карго, который принял товар. Если товар забирает третье лицо по доверенности, все риски переходят на клиента. Компания не несёт ответственность за содержимое посылок и претензии к интернет-магазинам.": "公司仅对已到达仓库并显示在网站上的商品负责。货物的保管责任仅由接收货物的货运分部承担。如由第三方凭委托书代取，所有风险由客户承担。公司对包裹内容及针对网店的索赔不承担责任。",
 "Можно ли отменить или вернуть заказ?": "订单可以取消或退货吗？",
 "Отмена возможна только до выкупа товара у продавца. После выкупа, поступления на склад или отправки в Казахстан отмена и возврат денежных средств категорически невозможны. По прибытию товара в Казахстан отказ от товара не допускается ни при каких обстоятельствах.": "仅在向卖家购买商品之前可以取消。商品购买后、到达仓库后或发往哈萨克斯坦后，一律不可取消或退款。商品抵达哈萨克斯坦后，在任何情况下均不得拒收。",
 "Как защищена моя личная информация?": "我的个人信息如何保护？",
 "Карго обеспечивает сохранность всей личной информации клиента. Карго не раскрывает личные данные третьим лицам, за исключением случаев, необходимых для исполнения обязательств по доставке товара. Карго не раскрывает содержимое заказов и не ведёт учёт количества товаров.": "货运公司保障客户所有个人信息的安全。除履行配送义务所必需的情形外，不会向第三方披露个人数据。不会披露订单内容，也不记录商品数量。",
 "Менеджер": "经理",
 "Услуги менеджера": "经理服务",
 "❓ Часто задаваемые вопросы": "❓ 常见问题",
 "⏰ График работы менеджера": "⏰ 经理工作时间",
 "📞 Телефон / WhatsApp:": "📞 电话 / WhatsApp：",
 "Понедельник": "星期一",
 "Выходной": "休息",
 "Вторник–Пятница": "星期二至星期五",
 "Суббота–Воскресенье": "星期六至星期日",
 "Скачать оферту (файл)": "下载要约（文件）",
 "← Вернуться на главную": "← 返回首页",
 "Требуется авторизация для доступа к QR функциям": "使用二维码功能需要登录",
 "Настройки": "设置",
 "Условия (файл):": "条款（文件）：",
 "Открыть": "打开",
 "не загружен": "未上传",
 "Адрес склада (chinaAddress):": "仓库地址（chinaAddress）：",
 "не указан": "未填写",
 "Номер WhatsApp менеджера:": "经理 WhatsApp 号码：",
 "Настройки не заданы": "尚未设置",
 "Условия": "条款",
 "Условия использования": "使用条款",
 "Ознакомьтесь с информацией о нашем сервисе": "了解我们的服务",
 "📺 Инструкция": "📺 使用说明",
 "Посмотреть видеоинструкцию →": "观看视频教程 →",
 "💬 Связь с нами": "💬 联系我们",
 "Написать в WhatsApp →": "通过 WhatsApp 联系 →",
 "ℹ️ О нас": "ℹ️ 关于我们",
 "⛔ Товары которые нельзя заказывать": "⛔ 禁止订购的商品",
 "📍 Адрес китайского склада": "📍 中国仓库地址",
 "📄 Документы": "📄 文件",
 "Скачать договор и условия": "下载合同和条款",
 "❓ Остались вопросы? Свяжитесь с нашей поддержкой": "❓ 还有疑问？请联系客服",
 "Адрес склада 291cargo": "291cargo 仓库地址",
 "Склад": "仓库",
 "Загрузка информации о складе...": "正在加载仓库信息...",
 "Наш склад в Китае": "我们在中国的仓库",
 "Отправьте посылку на этот адрес для дальнейшей доставки в Казахстан": "请将包裹寄到此地址，以便继续运往哈萨克斯坦",
 "Адрес склада": "仓库地址",
 "Адрес не задан": "尚未设置地址",
 "✓ Скопировано": "✓ 已复制",
 "📋 Скопировать": "📋 复制",
 "🔗 Поделиться": "🔗 分享",
 "Как отправить посылку?": "如何寄送包裹？",
 "Скопируйте адрес": "复制地址",
 "Нажмите кнопку \"Скопировать\" и скопируйте полный адрес нашего склада": "点击“复制”按钮，复制我们仓库的完整地址",
 "Оформите доставку": "安排发货",
 "Оформите доставку через местную логистическую компанию или доставку лично": "通过当地物流公司发货，或亲自送到仓库",
 "Получите трек-номер": "获取快递单号",
 "Отправьте нам номер отслеживания через чат с менеджером": "通过经理聊天窗口把快递单号发给我们",
 "Отслеживайте груз": "追踪货物",
 "Смотрите статус доставки в своем личном кабинете в разделе \"Посылки\"": "在您账户的“包裹”栏目查看配送状态",
 "💡 Полезные советы": "💡 实用提示",
 "✓ Убедитесь, что посылка хорошо упакована": "✓ 确保包裹包装牢固",
 "✓ Указывайте правильные размеры и вес": "✓ 填写正确的尺寸和重量",
 "✓ Проверьте список запрещенного содержимого": "✓ 查看违禁物品清单",
 "✓ Сохраняйте чеки и документы доставки": "✓ 保留收据和发货单据",
 "✓ Уведомляйте нас как можно раньше о отправке": "✓ 请尽早通知我们发货信息",
 "Вопросы по адресу складу? Свяжитесь с нашей поддержкой через менеджера": "对仓库地址有疑问？请通过经理联系客服",
 "💬 Написать менеджеру": "💬 联系经理",
 "Сообщения клиентам": "客户消息",
 "Все клиенты": "所有客户",
 "Филиал: {{v0}}": "分公司：{{v0}}",
 "Выбранные клиенты ({{v0}})": "选定的客户（{{v0}}）",
 "Выбранные клиенты": "选定的客户",
 "Не удалось загрузить данные": "数据加载失败",
 "выбранным клиентам: {{v0}}": "发送给选定的客户：{{v0}}",
 "всем клиентам филиала «{{v0}}»: {{v1}}": "发送给“{{v0}}”分公司的所有客户：{{v1}}",
 "всем клиентам: {{v0}}": "发送给所有客户：{{v0}}",
 "Отправить сообщение {{v0}}? Оно придёт на сайт, в push и в Telegram. Отменить отправку нельзя.": "确定发送消息{{v0}}？消息将发送到网站、推送和 Telegram，发送后无法撤销。",
 "Отправить": "发送",
 "Отправлено клиентам: {{v0}} (push: {{v1}}, Telegram: {{v2}})": "已发送给客户：{{v0}}（推送：{{v1}}，Telegram：{{v2}}）",
 "пропущено: {{v0}}": "已跳过：{{v0}}",
 "Не удалось отправить сообщение": "消息发送失败",
 "Сообщение появится в уведомлениях на сайте, придёт push и в Telegram (если клиент привязал бота).": "消息将显示在网站通知中，并通过推送和 Telegram 送达（如果客户已绑定机器人）。",
 "Кому": "收件人",
 "Всем клиентам филиала": "该分公司的所有客户",
 "Всем клиентам": "所有客户",
 "Выберите филиал": "请选择分公司",
 "Ваш филиал: {{v0}}. Писать можно только клиентам своего филиала.": "您的分公司：{{v0}}。只能给本分公司的客户发送消息。",
 "Поиск клиента: имя, телефон, ID...": "查找客户：姓名、电话、ID...",
 "Клиенты не найдены": "未找到客户",
 "Выбрать всех найденных": "选择全部结果",
 "Очистить": "清除",
 "Клиентов: {{v0}} · push-подписок у клиентов: {{v1}} · в Telegram: {{v2}}": "客户：{{v0}} · 开启推送的客户：{{v1}} · Telegram：{{v2}}",
 "Сообщение": "消息",
 "Заголовок": "标题",
 "Например: Ваша посылка прибыла": "例如：您的包裹已到达",
 "Текст": "正文",
 "Выберите хотя бы одного клиента": "请至少选择一位客户",
 "Последние рассылки": "最近发送记录",
 "Пока ничего не отправлялось": "尚未发送任何消息",
 "Отправитель": "发送人",
 "Получили": "已送达",
 "Вес посылки, г": "包裹重量（克）",
 "Изменить трек": "修改单号",
 "Итого за день": "当日合计",
 "Ищу посылку…": "正在查找包裹…",
 "Некорректный трек-номер": "单号格式不正确",
 "Новый вес для {{v0}}, г": "{{v0}} 的新重量（克）",
 "Общий вес, г": "总重量（克）",
 "Оставить": "保留",
 "Открывать камеру после каждой записи": "每次录入后自动打开相机",
 "Отсканируйте или введите трек": "请扫描或输入单号",
 "Посылка {{v0}} уже принималась {{v1}} ({{v2}}, {{v3}}). Принять ещё раз?": "包裹 {{v0}} 已于 {{v1}} 入库（{{v2}}，{{v3}}）。要再次入库吗？",
 "Принять ещё раз": "再次入库",
 "Приход за": "入库记录：",
 "Сканировать камерой": "用相机扫描",
 "Сумма к оплате": "应付金额",
 "Трек-номер": "单号",
 "Трек-номер посылки ({{v0}}, {{v1}})": "包裹单号（{{v0}}，{{v1}}）",
 "Укажите вес в граммах целым числом, например 268": "请以整数克输入重量，例如 268",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}})": "该包裹已于 {{v0}} 入库（{{v1}}，{{v2}}）",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}}). Проверьте, не дубль ли это.": "该包裹已于 {{v0}} 入库（{{v1}}，{{v2}}）。请确认是否重复。",
 "Этот трек уже принимался. Оставить всё равно?": "该单号已入库过。仍要保留吗？",
 "без трека": "无单号",
 "клиентов": "客户",
 "общий вес, г": "总重量（克）",
 "посылок: {{v0}}": "包裹：{{v0}}",
 "сумма к оплате": "应付金额",
 "Весь город": "全市",
 "всем клиентам города: {{v0}}": "发送给全市所有客户：{{v0}}",
 "Всем клиентам города": "全市所有客户",
 "Все филиалы города": "该城市所有分公司",
 "Ваш город: филиалы {{v0}}. Писать можно клиентам этих филиалов.": "您所在城市的分公司：{{v0}}。可以给这些分公司的客户发消息。",
 "Город (необязательно): филиалы одного города работают с клиентами друг друга": "城市（可选）：同一城市的分公司可互相处理对方客户",
 "Город:": "城市：",
 "Выбранным клиентам": "选定的客户",
 "Калькулятор": "运费计算",
 "Сколько стоит доставка": "运费是多少",
 "Не удалось загрузить тариф. Попробуйте позже.": "无法加载费率，请稍后再试。",
 "Тариф пока не задан. Уточните стоимость у менеджера филиала.": "费率尚未设置，请向分公司经理咨询价格。",
 "Ваш тариф: {{v0}} за кг": "您的费率：每公斤 {{v0}}",
 "ваш личный тариф": "您的个人费率",
 "тариф вашего филиала": "您所在分公司的费率",
 "общий тариф": "通用费率",
 "Вес посылки": "包裹重量",
 "Единицы веса": "重量单位",
 "г": "克",
 "Количество одинаковых посылок": "相同包裹数量",
 "Общий вес: {{v0}} г": "总重量：{{v0}} 克",
 "Введите вес, чтобы увидеть стоимость": "输入重量即可查看价格",
 "Расчёт примерный: итог определяется по весу посылки на складе.": "此为估算：最终价格以仓库称重为准。",
 "Размеры посылки, см (необязательно)": "包裹尺寸，厘米（可选）",
 "Длина, см": "长度，厘米",
 "Ширина, см": "宽度，厘米",
 "Высота, см": "高度，厘米",
 "Д": "长",
 "Ш": "宽",
 "В": "高",
 "Объёмный вес = Д × Ш × В / {{v0}}. Оплачивается большее из фактического и объёмного веса.": "体积重 = 长 × 宽 × 高 / {{v0}}。按实际重量与体积重中较大者计费。",
 "Расчётный вес: {{v0}} г": "计费重量：{{v0}} 克",
 "фактический: {{v0}} г": "实际：{{v0}} 克",
 "объёмный: {{v0}} г": "体积：{{v0}} 克",
 "Объёмный вес больше фактического — стоимость считается по нему.": "体积重大于实际重量，费用按体积重计算。",
 "Введите вес или размеры, чтобы увидеть стоимость": "输入重量或尺寸即可查看价格",
 "Коэффициент должен быть целым числом от 1000 до 20000, например 5000": "系数必须是 1000 到 20000 之间的整数，例如 5000",
 "Коэффициент объёмного веса сохранён": "体积重系数已保存",
 "Коэффициент объёмного веса": "体积重系数",
 "Д×Ш×В (см) / коэффициент = объёмный вес, кг. Показывается в калькуляторе клиентов": "长×宽×高（厘米）/ 系数 = 体积重（公斤），用于客户计算器",
 "Отчёты": "报表",
 "Должники": "欠款客户",
 "Не удалось загрузить должников": "无法加载欠款客户",
 "Не удалось загрузить сводку": "无法加载汇总",
 "Не удалось выгрузить файл": "无法导出文件",
 "Отправить {{v0}} напоминание об оплате ({{v1}})? Придёт на сайт, в push и в Telegram.": "向 {{v0}} 发送付款提醒（{{v1}}）？将发送到网站、推送和 Telegram。",
 "Напомнить": "提醒",
 "Напоминание отправлено": "提醒已发送",
 "Не удалось отправить напоминание": "提醒发送失败",
 "Давность долга": "欠款时长",
 "Любая давность": "不限",
 "Старше 7 дней": "超过 7 天",
 "Старше 14 дней": "超过 14 天",
 "Старше 30 дней": "超过 30 天",
 "Скачать CSV": "下载 CSV",
 "Должников нет": "没有欠款客户",
 "Счетов": "账单",
 "Дней": "天数",
 "Итого: должников {{v0}}": "合计：{{v0}} 位欠款客户",
 "Показаны первые 1000 должников.": "仅显示前 1000 位欠款客户。",
 "Приход и оплаты по дням": "按日入库与付款",
 "С даты": "起始日期",
 "По дату": "截止日期",
 "За этот период ничего не было": "该时间段内无记录",
 "Посылок": "包裹",
 "Вес, г": "重量（克）",
 "Выставлено": "已开账单",
 "Итого": "合计",
 "Журнал действий": "操作日志",
 "Журнал": "日志",
 "Тип действий": "操作类型",
 "Все действия": "全部操作",
 "Клиенты": "客户",
 "Тарифы": "费率",
 "Рассылки": "群发消息",
 "Входы": "登录",
 "админ": "管理员",
 "филиал": "分公司",
 "клиент": "客户",
 "Поиск: сотрудник или клиент": "搜索：员工或客户",
 "Записей нет": "没有记录",
 "Кто": "操作人",
 "Что сделал": "操作",
 "Над чем": "对象",
 "Подробности": "详情",
 "Страница {{v0}} из {{v1}}": "第 {{v0}} 页，共 {{v1}} 页",
 "записей: {{v0}}": "记录：{{v0}}",
 "Не удалось загрузить журнал": "无法加载日志",
 "Вход в систему": "登录系统",
 "Приёмка: добавлена посылка": "入库：已添加包裹",
 "Приёмка: изменена запись": "入库：记录已修改",
 "Приёмка: удалена запись": "入库：记录已删除",
 "Приёмка: выставлены счета": "入库：已开账单",
 "Счёт выставлен": "账单已开具",
 "Счёт изменён": "账单已修改",
 "Счёт отмечен оплаченным": "账单已标记为已付",
 "Клиент: данные изменены": "客户：资料已修改",
 "Клиент удалён": "客户已删除",
 "Личный тариф клиента": "客户个人费率",
 "Процент бонуса клиента": "客户积分比例",
 "Бонусы начислены": "积分已发放",
 "Бонусы списаны": "积分已扣除",
 "Филиал добавлен": "分公司已添加",
 "Филиал изменён": "分公司已修改",
 "Филиал удалён": "分公司已删除",
 "Реквизиты филиала": "分公司收款信息",
 "Тариф филиала": "分公司费率",
 "Настройки изменены": "设置已修改",
 "Общий процент бонуса": "通用积分比例",
 "Рассылка клиентам": "客户群发",
 "Сверка оплат с отчётом Kaspi": "与 Kaspi 报表核对付款",
 "Загрузить PDF-отчёт": "上传 PDF 报表",
 "PDF-отчёт Kaspi": "Kaspi PDF 报表",
 "Загрузите ежедневный «Отчёт по продажам» из Kaspi Pay. В нём есть время и сумма, но нет имён, поэтому счета ищутся по сумме. Файл читается в вашем браузере.": "请上传 Kaspi Pay 的每日“销售报表”。其中只有时间和金额，没有姓名，因此按金额匹配账单。文件在您的浏览器中读取。",
 "Или вставьте текст отчёта": "或粘贴报表文本",
 "Текст отчёта": "报表文本",
 "Разобрать текст": "解析文本",
 "Не удалось разобрать отчёт": "无法解析报表",
 "Не удалось прочитать PDF": "无法读取 PDF",
 "продаж: {{v0}} на {{v1}}": "销售 {{v0}} 笔，共 {{v1}}",
 "однозначных: {{v0}}": "明确匹配：{{v0}}",
 "спорных: {{v0}}": "有歧义：{{v0}}",
 "без счёта: {{v0}}": "无账单：{{v0}}",
 "уже обработано: {{v0}}": "已处理：{{v0}}",
 "Отметить оплату {{v0}}": "标记付款 {{v0}}",
 "Выбор счёта {{v0}}": "为 {{v0}} 选择账单",
 "— выберите счёт —": "— 请选择账单 —",
 "нет неоплаченного счёта на эту сумму": "没有该金额的未付账单",
 "пропущена": "已跳过",
 "обработана: {{v0}}": "已处理：{{v0}}",
 "Пропустить": "跳过",
 "Отметить оплаченными счета: {{v0}} на сумму {{v1}}? Клиенты получат уведомление.": "将 {{v0}} 张账单标记为已付，共 {{v1}}？客户将收到通知。",
 "Отметить": "标记",
 "Отмечено оплаченными: {{v0}}": "已标记为已付：{{v0}}",
 "не отмечено: {{v0}} ({{v1}})": "未标记：{{v0}}（{{v1}}）",
 "Не удалось отметить оплаты": "无法标记付款",
 "Пропустить продажу {{v0}} на {{v1}}? Она больше не будет предлагаться.": "跳过 {{v0}} 的销售（{{v1}}）？之后将不再提示。",
 "Не удалось пропустить": "无法跳过",
 "Отметить выбранные оплаченными ({{v0}})": "将所选标记为已付（{{v0}}）",
 "уже обработана": "已处理",
 "счёт уже не ожидает оплаты": "账单已不在待付状态",
 "сумма не совпала": "金额不一致",
 "нет доступа к клиенту": "无权访问该客户",
 "счёт не найден": "未找到账单",
 "некорректные данные": "数据无效",
 "ошибка": "错误",
 "Загрузка отправок из файла": "导入发货文件",
 "Оплата Kaspi пропущена": "已跳过Kaspi付款",
 "Отправки": "发货",
 "Оплаты Kaspi": "Kaspi付款",
 "Режим": "模式",
 "Отправлен": "已发货",
 "Прибыл": "已到达",
 "Код": "代码",
 "Всего": "总计",
 "Создано": "已创建",
 "Обновлено": "已更新",
 "Уже было": "已有",
 "Дальше по статусу": "状态更靠后",
 "Другая дата": "其他日期",
 "Оплатить онлайн": "在线支付",
 "Карта, Apple Pay, Google Pay": "银行卡、Apple Pay、Google Pay",
 "Не удалось создать платёж. Попробуйте позже.": "无法创建付款，请稍后重试。",
 "Спасибо! Оплата принята, статус счёта обновится в течение минуты.": "谢谢！已收到付款，账单状态将在一分钟内更新。",
 "Оплата не прошла. Попробуйте ещё раз.": "付款失败，请重试。",
 "Тестовая оплата получена (счёт в тестовом режиме не закрывается).": "已收到测试付款（测试模式下账单不会关闭）。",
 "Оплата получена, но счёт закрыть не удалось. Свяжитесь с филиалом, мы всё проверим.": "已收到付款，但无法关闭账单。请联系分店，我们会核实。",
 "Активность клиентов": "客户活跃度",
 "Заходили сегодня": "今日访问",
 "за 7 дней": "7天内",
 "за 30 дней": "30天内",
 "всего клиентов": "客户总数",
 "Отметки о заходах копятся с момента включения функции.": "访问记录从功能启用时开始累积。",
 "Кто заходил сегодня": "今日访问者",
 "Скрыть список": "隐藏列表",
 "Последний визит": "最近访问",
 "вчера": "昨天",
 "Счёт (ID)": "账单（ID）",
 "Источник": "来源",
 "Заказ": "订单",
 "Пропущено": "已跳过",
 "Поля": "字段",
 "Получателей": "收件人",
 "Город": "城市",
 "Телефон владельца": "所有者电话",
 "Владелец (ID)": "所有者（ID）",
 "Цена": "价格",
 "Валюта": "货币",
 "Личный тариф": "个人资费",
 "Процент бонуса": "奖励比例",
 "Коэффициент": "系数",
 "Код клиента": "客户代码",
 "Пароль изменён": "密码已更改",
 "Ссылка оплаты изменена": "付款链接已更改",
 "да": "是",
 "онлайн-оплата Freedom Pay": "Freedom Pay 在线支付",
 "онлайн-оплата Freedom Pay (тест)": "Freedom Pay 在线支付（测试）",
 "онлайн-оплата: не засчитана": "在线支付：未入账",
 "отчёт Kaspi": "Kaspi 报告",
 "вручную": "手动",
 "таблица": "表格",
 "приёмка": "收货",
 "Документы": "文件",
 "Политика конфиденциальности": "隐私政策",
 "Возврат средств": "退款",
 "ИИН": "个人识别号",
 "Тел.:": "电话：",
 "Режим работы": "营业时间",
 "выдача посылок": "包裹领取",
 "Выдача посылок": "包裹领取",
 "с 9:00 до 20:00": "9:00 至 20:00",
 "круглосуточно": "全天候",
 "Оплата банковскими картами Visa и Mastercard, Apple Pay и Google Pay через платёжный шлюз Freedom Pay. Мы не храним данные банковских карт.": "通过 Freedom Pay 支付网关使用 Visa 和 Mastercard 银行卡、Apple Pay 和 Google Pay 付款。我们不保存银行卡数据。",
 "На главную": "返回首页",
 "Адрес": "地址",
 "Реквизиты": "信息",
 "Реквизиты исполнителя": "服务方信息",
 "Торговая марка": "商标",
 "Другие города": "其他城市",
 "Темиртау": "捷米尔套",
 "Астана": "阿斯塔纳",
 "Принимаем к оплате": "接受支付",
 "Запрещённые товары": "禁运物品",
 "⛔ Запрещённые и хрупкие товары": "⛔ 禁运和易碎物品",
 "Открыть полный список →": "查看完整清单 →",
 "🎬 Видеоинструкции": "🎬 视频教程",
 "Видеоинструкции": "视频教程",
 "Не удалось загрузить видеоинструкции": "无法加载视频教程",
 "Сохранено": "已保存",
 "Название и ссылка (например, на YouTube). Показываются клиентам в боте (/video) и на странице «Условия».": "标题和链接（例如 YouTube）。向客户显示在机器人（/video）和“条款”页面。",
 "Название": "标题",
 "Ссылка": "链接",
 "+ Добавить видео": "+ 添加视频",
 "Сохранить видеоинструкции": "保存视频教程",
 "📲 Подключите Telegram": "📲 绑定 Telegram",
 "Уведомления о посылках и счетах, список посылок и добавление треков прямо в чате.": "包裹和账单通知、包裹列表，并可直接在聊天中添加单号。",
 "Подключить": "绑定",
 "Позже": "稍后",
 "Коды клиентов": "客户代码",
 "Не удалось загрузить коды клиентов": "无法加载客户代码",
 "Не удалось выдать код": "无法发放代码",
 "Сообщение скопировано": "消息已复制",
 "Не удалось скопировать": "无法复制",
 "Выдайте клиенту код и номер телефона: зарегистрироваться можно только по этой паре. Отправьте код клиенту в личном сообщении (WhatsApp или Telegram).": "为客户发放代码和手机号：只能凭这一组信息注册。请通过私信（WhatsApp 或 Telegram）把代码发给客户。",
 "Номер телефона клиента": "客户手机号",
 "Код клиента (латиницей)": "客户代码（拉丁字母）",
 "Выдать код": "发放代码",
 "Код выдан": "代码已发放",
 "Скопировать сообщение клиенту": "复制给客户的消息",
 "Выданные коды": "已发放的代码",
 "Кодов пока нет": "暂无代码",
 "Выдал": "发放人",
 "Скопировать": "复制",
 "Ожидает регистрации": "等待注册",
 "Зарегистрирован": "已注册",
 "Срок истёк": "已过期",
 "Адрес для этого филиала не задан: заполните его в «Мой карго» → Настройки филиала": "此分店未设置地址：请在“我的货运”→分店设置中填写",
 "Адрес пока не задан, уточните его у менеджера": "地址尚未设置，请向经理咨询",
 "Как адрес выглядит в приложении": "地址在应用中的样子",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента (на примере он показан как «КОД КЛИЕНТА»). Адрес на примере для Темиртау; для вашего филиала скопируйте адрес выше.": "在中国购物应用中添加仓库地址，并在“详细地址”末尾填写您的客户代码（示例中显示为“КОД КЛИЕНТА”）。示例为捷米尔套；请复制上方您所在分店的地址。",
 "Заполнение адреса: в конце детального адреса стоит код клиента": "填写地址：详细地址末尾为客户代码",
 "Сохранённый адрес с кодом клиента": "含客户代码的已保存地址",
 "1. Вставьте адрес и допишите в конце свой код клиента": "1. 粘贴地址并在末尾加上您的客户代码",
 "2. Сохранённый адрес: код клиента стоит в конце": "2. 已保存的地址：客户代码在末尾",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента.": "在中国购物应用中添加仓库地址，并在“详细地址”末尾填写您的客户代码。",
 "Адрес вашего филиала в приложении": "应用中您所在分店的地址",
 "в конце адреса стоит код клиента": "客户代码位于地址末尾",
 "Теперь это сотрудник филиала": "该用户现为分店员工",
 "Возвращён в клиенты": "已恢复为客户",
 "Не удалось изменить роль": "无法更改角色",
 "сотрудник филиала": "分店员工",
 "Филиал сотрудника": "员工所属分店",
 "Сделать сотрудником филиала": "设为分店员工",
 "Вернуть в клиенты": "恢复为客户",
 "Забыли пароль?": "忘记密码？",
 "Через Telegram": "通过 Telegram",
 "Бот пришлёт кнопку со ссылкой. Она действует 15 минут и сработает один раз: откройте её и задайте новый пароль.": "机器人会发送带链接的按钮。链接仅可使用一次，15 分钟内有效：打开后设置新密码。",
 "Открыть бот в Telegram": "在 Telegram 中打开机器人",
 "Без Telegram": "没有 Telegram",
 "Обратитесь к представителю своего филиала: он отправит вам ссылку для смены пароля в личном сообщении.": "请联系您所在分店的代表：他们会通过私信向您发送重置密码的链接。",
 "← Вернуться ко входу": "← 返回登录",
 "Новый пароль": "新密码",
 "Проверяем ссылку...": "正在检查链接...",
 "Как восстановить пароль": "如何找回密码",
 "Пароли не совпадают": "两次输入的密码不一致",
 "Не удалось сменить пароль": "无法修改密码",
 "Повторите пароль": "再次输入密码",
 "Сменить пароль": "修改密码",
 "Пароль изменён. Теперь можно войти с новым паролем.": "密码已修改。现在可以用新密码登录。",
 "Отправить ссылку для смены пароля": "发送重置密码链接",
 "Не удалось создать ссылку": "无法生成链接",
 "Ссылка отправлена клиенту в Telegram.": "链接已通过 Telegram 发送给客户。",
 "У клиента не подключён Telegram: скопируйте сообщение и отправьте ему в WhatsApp.": "客户未绑定 Telegram：请复制消息并通过 WhatsApp 发送。",
 "Ссылка действует 15 минут и сработает один раз.": "链接仅可使用一次，15 分钟内有效。",
 "Нажмите кнопку «Открыть бот в Telegram» ниже и в Telegram нажмите «Старт». Если бот уже открыт, нажмите в его меню кнопку «🔑 Забыл пароль».": "点击下方“在 Telegram 中打开机器人”，然后在 Telegram 中点击“开始”。如果机器人已打开，请点击其菜单中的“🔑 忘记密码”。",
 "Ссылка недействительна или устарела. Запросите новую: в боте нажмите «🔑 Забыл пароль» или попросите представителя филиала.": "链接无效或已过期。请重新获取：在机器人中点击“🔑 忘记密码”，或请分店代表协助。",
 "Если бот ещё не подключён к вашему аккаунту, поделитесь контактом кнопкой в чате: так мы убеждаемся, что номер ваш.": "如果机器人尚未绑定您的账号，请用聊天中的按钮分享联系人：这样我们可以确认号码属于您。",
 "Заявки": "申请",
 "Не удалось загрузить заявки": "无法加载申请",
 "Заявки на обрешётку и инспекцию, которые клиенты отправили через Telegram-бота до поступления товара на склад. Новые заявки приходят и сообщением в Telegram представителю филиала.": "客户在货物到达仓库之前通过 Telegram 机器人提交的打木架和验货申请。新申请也会通过 Telegram 消息发送给分点负责人。",
 "Новых заявок": "新申请",
 "Только новые": "仅新申请",
 "Заявок нет": "暂无申请",
 "Услуга": "服务",
 "Обрешётка": "打木架",
 "Инспекция": "验货",
 "Обрешётка + инспекция": "打木架 + 验货",
 "Новая": "新",
 "Выполнена": "已完成",
 "Отменена": "已取消",
 "Выполнено": "已完成",
 "Вернуть в новые": "恢复为新申请",
 "Привет! Закажи доставку из Китая в 291cargo. При регистрации укажи мой номер": "你好！通过 291cargo 订购中国发货。注册时请填写我的号码",
 "Приглашение скопировано": "邀请已复制",
 "Реферальная программа": "推荐计划",
 "Сейчас программа недоступна для вашего филиала.": "该计划目前不适用于您所在的分点。",
 "Ваша скидка на вес": "您的重量折扣",
 "Активных приглашённых": "活跃的被邀请人",
 "У вас личный (VIP) тариф: реферальная скидка с ним не суммируется.": "您使用个人（VIP）费率：推荐折扣不可叠加。",
 "Скидка начисляется на плату за вес при выставлении счёта. Процент фиксируется в момент выставления счёта.": "折扣在开具账单时按重量费用计算，比例在开单时即固定。",
 "Как это работает": "如何运作",
 "Дайте новому клиенту свой номер телефона": "把您的手机号告诉新客户",
 "При регистрации он вводит ваш номер в поле «Номер пригласившего».": "注册时，对方在“推荐人手机号”栏填写您的号码。",
 "Каждый приглашённый, у которого за последние {{v0}} дн. не меньше {{v1}} посылок на складе, даёт вам {{v2}}% скидки (максимум {{v3}}%).": "过去 {{v0}} 天内仓库至少有 {{v1}} 个包裹的被邀请人，每位为您带来 {{v2}}% 折扣（最高 {{v3}}%）。",
 "Пригласить друга": "邀请朋友",
 "Привязать можно только нового клиента при его регистрации. Себя и уже зарегистрированных указать нельзя.": "只能在新客户注册时绑定。不能填写自己或已注册的客户。",
 "Ваши приглашённые": "您邀请的人",
 "Пока никого нет": "暂无",
 "Посылок за {{v0}} дн.": "{{v0}} 天内包裹",
 "Активен": "活跃",
 "Не активен": "不活跃",
 "Не удалось загрузить настройки": "无法加载设置",
 "Клиент приводит новых клиентов (они указывают его номер при регистрации) и получает скидку на вес. Приглашённый активен, если за период у него не меньше заданного числа посылок, прибывших на склад. С личным (VIP) тарифом скидка не действует.": "客户推荐新客户（对方注册时填写其号码）即可获得重量折扣。被推荐人在周期内到达仓库的包裹数不少于设定值时视为活跃。个人（VIP）费率不适用该折扣。",
 "Программа включена": "计划已启用",
 "Процент за одного активного, %": "每位活跃被邀请人的比例，%",
 "Максимальная скидка, %": "最高折扣，%",
 "Минимум посылок у приглашённого": "被邀请人最少包裹数",
 "Период активности, дней": "活跃周期，天",
 "Программа действует для клиентов только тех филиалов, где она включена.": "该计划仅适用于已启用的分点的客户。",
 "Кто сколько привёл": "谁邀请了多少人",
 "Приведено": "已邀请",
 "Активных": "活跃",
 "Скидка": "折扣",
 "выкл.": "关",
 "VIP-тариф": "VIP 费率",
 "Адрес склада сохранён": "仓库地址已保存",
 "Адрес склада филиала": "分点仓库地址",
 "Этот адрес видит клиент в разделе «Склад», он же копируется кнопкой «Скопировать адрес склада». Вместо кода клиента пишите «КОД КЛИЕНТА» — подставится автоматически.": "客户在“仓库”栏看到此地址，“复制仓库地址”按钮复制的也是它。请用“КОД КЛИЕНТА”代替客户代码，系统会自动替换。",
 "Адрес не задан — клиентам показывается общий адрес": "未设置——客户将看到通用地址",
 "Сохранить адрес": "保存地址",
 "Тарифы, реквизиты и история": "费率、收款信息和历史"
};

export default dict;
